function buildRouteUrl(
  baseUrl: string,
  queries?: { name: string; value: string }[]
): any {
  const query = Object.fromEntries(
    (queries || [])
      .filter(item => item.value)
      .map(item => [item.name, item.value])
  );
  const pathname = baseUrl.split('?')[0].replace(/\/$/, '') || '/';
  const existingQuery = Object.fromEntries(
    new URLSearchParams(baseUrl.includes('?') ? baseUrl.split('?')[1] : '')
  );
  const finalQuery = { ...existingQuery, ...query };
  const routeMatchers: {
    pattern: RegExp;
    pathname: string;
    keys: string[];
  }[] = [
    {
      pattern: /^\/watch-providers\/([^/]+)\/all$/,
      pathname: '/watch-providers/[slug]/all',
      keys: ['slug']
    },
    {
      pattern: /^\/users\/([^/]+)\/watch-list\/movies$/,
      pathname: '/users/[id]/watch-list/movies',
      keys: ['id']
    },
    {
      pattern: /^\/users\/([^/]+)\/watch-list\/tvs$/,
      pathname: '/users/[id]/watch-list/tvs',
      keys: ['id']
    },
    {
      pattern: /^\/person\/([^/]+)\/tv-shows$/,
      pathname: '/person/[id]/tv-shows',
      keys: ['id']
    },
    {
      pattern: /^\/person\/([^/]+)\/movies$/,
      pathname: '/person/[id]/movies',
      keys: ['id']
    },
    {
      pattern: /^\/genres\/([^/]+)\/(movies|tv)$/,
      pathname: '/genres/[id]/$2',
      keys: ['id']
    },
    {
      pattern: /^\/users\/([^/]+)\/lists$/,
      pathname: '/users/[id]/lists',
      keys: ['id']
    },
    ...['movie', 'tv', 'episode', 'person', 'genres', 'lists', 'users'].map(
      resource => ({
        pattern: new RegExp(`^/${resource}/([^/]+)$`),
        pathname: `/${resource}/[id]`,
        keys: ['id']
      })
    )
  ];

  for (const matcher of routeMatchers) {
    const match = pathname.match(matcher.pattern);

    if (match) {
      const dynamicPathname = matcher.pathname.replace('$2', match[2] || '');
      const params = Object.fromEntries(
        matcher.keys.map((key, index) => [key, match[index + 1]])
      );

      return {
        pathname: dynamicPathname,
        params,
        ...(Object.keys(finalQuery).length > 0 ? { query: finalQuery } : {})
      };
    }
  }

  if (
    [
      '/',
      '/in_theaters',
      '/trending',
      '/popular',
      '/tv-time-alternative'
    ].includes(pathname)
  ) {
    return {
      pathname,
      ...(Object.keys(finalQuery).length > 0 ? { query: finalQuery } : {})
    };
  }

  const serialized = new URLSearchParams(finalQuery).toString();

  return `${pathname}${serialized ? `?${serialized}` : ''}`;
}

export default buildRouteUrl;
